var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUparrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 131,
    height: 131,
    viewBox: "0 0 131 131",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M88.4796 87.3333H42.5204C40.706 87.3359 38.928 86.8247 37.392 85.8587C35.8561 84.8927 34.6252 83.5115 33.8417 81.875C32.9245 79.9332 32.5713 77.7729 32.8222 75.6401C33.0731 73.5073 33.9181 71.4879 35.2609 69.8121L58.2404 41.9746C59.1422 40.934 60.2572 40.0995 61.5097 39.5276C62.7623 38.9557 64.1231 38.6597 65.5 38.6597C66.877 38.6597 68.2378 38.9557 69.4903 39.5276C70.7429 40.0995 71.8578 40.934 72.7596 41.9746L95.7392 69.8121C97.082 71.4879 97.927 73.5073 98.1779 75.6401C98.4288 77.7729 98.0755 79.9332 97.1584 81.875C96.3749 83.5115 95.1439 84.8927 93.608 85.8587C92.0721 86.8247 90.294 87.3359 88.4796 87.3333Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUparrow);
export default __webpack_public_path__ + "static/media/uparrow.da7004711897581a4817eea4185991ee.svg";
export { ForwardRef as ReactComponent };